import {useEffect,useState} from 'react';

function useSidebarHidden(containerClass = '.content-container') {

      const [sideBarHidden, setSideBarHidden] = useState(false);
      const SIDEBAR_WIDTH = 230
    
    useEffect(() => {
      const container = document.querySelector(containerClass);
      if (!container) return;
    
      const initialWidth = container.getBoundingClientRect().width;
      setSideBarHidden(initialWidth > window.innerWidth - SIDEBAR_WIDTH);
    
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const width = entry.contentRect.width;
          const isSidebarHidden = width > window.innerWidth - SIDEBAR_WIDTH;
          setSideBarHidden(isSidebarHidden);
        }
      });
      observer.observe(container);
      return () => observer.disconnect();
    }, [containerClass]);

  return sideBarHidden;
}

export default useSidebarHidden;